<template>
    <div id="page_Container" title="新增地址">
        <div class="page">
            <div id='main-container' class="main-container">
                <div class="company-wrapper">
                    <img class="location_icon" src="../assets/img/home/companyAddress.png" alt="">
                    <span class="companyName">{{subcompanyName}}</span>
                    <div class="sanjiao_down"></div>
                </div>
                <div class="companyList-wrapper">
                    <div class="currentCompany">
                        <div class="desc">当前/已选子公司</div>
                        <div class="item-name"><span class="active name">{{subcompanyName}}</span></div>
                    </div>
                    <div class="list-wrapper">
                        <div class="list-title">子公司列表</div>
                        <div class="list-item" v-for="(item, index) in companyList" :key="index" @click.stop="selectCompany(item)">
                            <div class="item-name"><span class="name">{{item.subcompanyName}}</span></div>
                            <div class="list-area-box">
                                <div class="area-item">{{item.subcompanyAddress}}</div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="list-item" v-for="(item, index) in companyList" :key="index">
                        <div class="item-name"><span:class="[name, {'active': currentIndex === index}]" @click="selectCompany">{{item.subcompanyName}}</span></div>
                        <div class="list-area-box">
                            <div class="area-item">贵阳市-白云区</div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    toastLoading,
    clearToastLoading
} from '@/utils/base/utils';
import { Toast } from 'vant';
export default {
    data() {
        return {
            companyList: [],
            subcompanyName: ''
        };
    },
    esvShow() {
        this.querySubcompanyList();
        this.subcompanyName = this.$route.params.subcompanyName;
    },
    methods: {
        selectCompany(item) {
            this.ESVStorage.putSavedValue('shortCode', item.shortCode);
            this.setSubcompanySession(item);
        },
        setSubcompanySession(item) {
            const ths = this;
            ths.$doRequest({
                url: '/merchant/setSubcompanySession',
                params: {
                    subcompanyShortCode: item.shortCode
                },
                before: function () {
                    ths.loading = toastLoading();
                },
                complete: function () {
                    clearToastLoading(ths.loading);
                }
            },
            function (data) {
                if (data.responseCode === '100000') {
                    ths.esvBackPage(1);
                } else {
                    Toast(data.message);
                }
            }
            );
        },
        querySubcompanyList() {
            const ths = this;
            ths.$doRequest({
                url: '/merchant/querySubcompanyList',
                params: {

                },
                before: function () {
                    ths.loading = toastLoading();
                },
                complete: function () {
                    clearToastLoading(ths.loading);
                }
            },
            function (data) {
                if (data.responseCode === '100000') {
                    ths.companyList = data.result;
                    ths.ESVStorage.getSavedValue('shortCode', (data) => {
                        ths.companyList.forEach((list, index) => {
                            if (list.shortCode === data) {
                                ths.currentIndex = index;
                            }
                        });
                    });
                }
            }
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.company-wrapper {
    display: flex;
    align-items: center;
    background: transparent;
    padding: 12px;

    .companyName {
        color: #000;
        font-size: 12px;
        margin: 0 5px;
    }

    .location_icon {
        width: 10px;
    }
}

/**向下的三角**/
.sanjiao_down {
    margin-top: 3px;
    width: 0;
    height: 0;
    overflow: hidden;
    font-size: 0;
    /*是因为, 虽然宽高度为0, 但在IE6下会具有默认的 */
    line-height: 0;
    /* 字体大小和行高, 导致盒子呈现被撑开的长矩形 */
    border-width: 4px;
    border-style: solid dashed dashed dashed;
    /*IE6下, 设置余下三条边的border-style为dashed,即可达到透明的效果*/
    border-color: #000 transparent transparent transparent;
}

.companyList-wrapper {
    .currentCompany {
        padding-left: 12px;
        background: #fff;
        margin-bottom: 10px;
        overflow: hidden;

        .desc {
            color: #414141;
            font-size: 14px;
            padding-top: 10px;
        }

        .item-name {
            margin: 10px 0;
            font-size: 12px;
            box-sizing: border-box;
        }

        .active {
            border: 1px solid #EE2E50;
            color: #EE2E50;
            padding: 4px 10px;
        }
    }

    .list-title {
        color: #414141;
        font-size: 14px;
        margin-bottom: 5px;
        padding: 11px 12px 0;
    }

    .list-wrapper {
        background: #fff;
    }

    .list-item {
        padding: 10px 12px 0;
        background: #fff;
        overflow: hidden;
        position: relative;

        .item-name {
            margin-bottom: 7px;
            font-size: 12px;

            .name {
                position: relative;
                color: #666;
                text-align: center;
            }
        }

        .list-area-box {
            display: flex;
            flex-wrap: wrap;

            .area-item {
                // width: calc(calc(100% / 3) - 18px);
                margin: 0 0 10px;
                // background: #F6F6F6;
                color: #666;
                // text-align: center;
            }
        }
    }

    .list-item + .list-item::after {
        content: '';
        position: absolute;
        bottom: 0;
        width: 100%;
        border-top: 1px solid #E3E2E2;
        left: -12px;
        right: -12px;
    }
}
</style>
